export default __webpack_public_path__ + "static/media/icon-vertical-dots.34604f60.svg";